<template>
  <div class="signature-profiles-index">
    <TableWrapper
      :tableColumns="signatureProfilesColumns"
      table-key="signatureProfiles"
      row-key="id"
      @updateCredentials="handleOpenModal"
    />

    <SendCredentialsModal
      v-if="openSendCredentialsModal"
      :profile-id="selectedProfile.userId"
      @dialogClose="handleCloseModal"
    />
  </div>
</template>

<script>
  import { mapActions, mapGetters } from 'vuex';
  import { signatureProfilesColumns } from '@/config';
  import { signatureProfilesApi } from '@/api';
  import TableWrapper from '@/components/TableWrapper.vue';
  import SendCredentialsModal from './SendCredentialsModal.vue';

  export default {
    name: 'SignatureProfilesIndex',
    components: {
      TableWrapper,
      SendCredentialsModal,
    },
    data() {
      return {
        signatureProfilesColumns,
        openSendCredentialsModal: false,
        selectedProfile: null,
      };
    },
    computed: {
      ...mapGetters(['tableFilters']),
    },
    methods: {
      ...mapActions([
        'updateTableRows',
        'updateTableCount',
        'parseQueryStringStatus',
      ]),
      async tableRows() {
        try {
          const profilesIndex = await signatureProfilesApi.profilesIndex(
            this.tableFilters('signatureProfiles')
          );
          const profilesCount = await signatureProfilesApi.profilesCount();

          this.updateTableRows({
            tableKey: 'signatureProfiles',
            rows: profilesIndex.data,
          });
          this.updateTableCount({
            tableKey: 'signatureProfiles',
            count: profilesCount.data.count,
          });
        } catch (error) {
          this.$notify({
            showClose: true,
            type: 'error',
            message: error.response.data.error.message,
          });
        }
      },
      handleOpenModal(row) {
        this.selectedProfile = row;
        this.openSendCredentialsModal = true;
      },
      handleCloseModal() {
        this.selectedProfile = null;
        this.openSendCredentialsModal = false;
      },
    },
    created() {
      this.parseQueryStringStatus(this.$route.query);
      this.tableRows();
    },
    beforeRouteUpdate(to, from, next) {
      this.parseQueryStringStatus(to.query);
      this.tableRows();
      next();
    },
  };
</script>
